import React from 'react';
import PropTypes from 'prop-types';
import Subscriber from 'resources/subscriber';
import $ from 'jquery';

class ResendConfirmationLink extends React.Component {
  _success() {
    HRB.utils.notify(`Sent confirmation link to: ${this.props.email}.`);
  }

  _failure() {
    HRB.utils.notify('Unable to send confirmation link. Try again soon.');
  }

  _resendSubscriberConfirmation () {
    if (this.props.destination === 'manage') {
      Subscriber.resendConfirmation(this.props.pageCode, this.props.subscriberCode).then(this._success.bind(this), this._failure);
    } else {
      $.post(`/resend_confirmation/${this.props.subscriberCode}`).done(this._success.bind(this)).fail(this._failure);
    }
    return false;
  }

  render () {
    return <a href="#"
              onClick={() => this._resendSubscriberConfirmation()}
              ref="anchor">{this.props.text}</a>;
  }
}

ResendConfirmationLink.propTypes = {
  pageCode: PropTypes.string.isRequired, // Page of the subscriber
  subscriberCode: PropTypes.string.isRequired, // The subscriber code itself
  text: PropTypes.string.isRequired, // The text to display with the link
  email: PropTypes.string.isRequired, // The email to display in the success prompt
  destination: PropTypes.oneOf(['status', 'manage']).isRequired, // There are two API endpoints to simplify calling from admin and subscriber contexts.
};

module.exports = ResendConfirmationLink;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/resend_confirmation_link.jsx